/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = () => {
  const dataColumns = [
    {
      field: 'id',
      title: 'ID#',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 150,
    },
    {
      field: 'first_name',
      title: 'First Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'last_name',
      title: 'Last Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'status',
      title: 'Status',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
  ];

  return dataColumns;
};
export default DataColumns;
